export const endpoint = {
	base: "",
	questionSheet: "/question-sheet/:enqueteId",
	rawdata: "/rawdata/:enqueteId",
} as const;
